import { useQueryClient } from '@tanstack/react-query';
import { useApiMutation } from '@/api/hooks/useMutation';
import { addressKeys } from '@/api/queryKeys';
import type {
  CreateUserVerifiedAddressRequest,
  CreateUserVerifiedAddressResponse,
} from '@bvengineering/cas-member-gateway-service-client';

/**
 * Hook to verify/create a new address.
 * Uses the Api container's settings client.
 *
 * The address is validated against a verification service and saved if valid.
 * Returns a verified address with an ID that can be used when claiming campaigns.
 */
export function useVerifyAddress() {
  const queryClient = useQueryClient();

  return useApiMutation<CreateUserVerifiedAddressResponse, Error, CreateUserVerifiedAddressRequest>(
    {
      mutationFn: (api) => async (address: CreateUserVerifiedAddressRequest) => {
        const response = await api.settings.settingsControllerVerifyAddress(address);
        return response.data;
      },
      onSuccess: () => {
        // Invalidate verified addresses to refetch
        return queryClient.invalidateQueries({ queryKey: addressKeys.verified() });
      },
    }
  );
}
